import React from 'react';
import { Radio as CRadio, RadioProps as CRadioProps } from '@chakra-ui/react';

interface RadioProps extends CRadioProps {}

export const Radio: React.FC<RadioProps> = (props) => <CRadio {...props} />;
